package er.prateek.crossly.progression

/**
 * Bands a completed puzzle's hint/mistake count into a 1-3 star score.
 * Thresholds are deliberately simple and centralized here so they can be
 * tuned (or made per-tier/Remote-Config-driven) without touching call sites.
 */
object ScoringPolicy {
    fun starsFor(hintsUsed: Int, mistakes: Int): Int = when {
        hintsUsed == 0 && mistakes == 0 -> 3
        hintsUsed <= 1 && mistakes <= 2 -> 2
        else -> 1
    }
}
